import Vue from 'vue'
import Cleave from 'cleave.js';

Vue.directive('cleave', {
    inserted: (el, binding) => {
        const input = el.children[1].children[0];
        input.cleave = new Cleave(input, binding.value || {})
    },
    update: (el) => {
        const event = new Event('input', {bubbles: true});
        const input = el.children[1].children[0];
        setTimeout(function () {
           if(input.cleave.properties.result){
            input.value = input.cleave.properties.result
            input.dispatchEvent(event)
           }
            
        }, 100);
    }
})